import { Loader2 } from "lucide-react";

interface DeleteCauseModalProps {
  isDeleting: boolean;
  onCancel: () => void;
  onConfirm: () => void;
}

const DeleteCauseModal = ({
  isDeleting,
  onCancel,
  onConfirm,
}: DeleteCauseModalProps) => {
  return (
    <div className="fixed inset-0 z-50 flex items-center justify-center bg-black/40">
      <div className="bg-white rounded-xl shadow-xl p-6 w-full max-w-xs">
        <h3 className="text-lg font-semibold mb-4 text-gray-900">
          Delete Case?
        </h3>
        <p className="text-gray-700 mb-6">
          Are you sure you want to delete this case?
        </p>
        <div className="flex justify-end gap-3">
          <button
            className="px-4 py-2 rounded-lg border border-gray-300 text-gray-700 hover:bg-gray-100"
            onClick={onCancel}
          >
            Cancel
          </button>
          <button
            className="px-4 py-2 rounded-lg bg-red-600 text-white hover:bg-red-700 disabled:opacity-50 disabled:cursor-not-allowed min-w-25 flex items-center justify-center gap-2"
            disabled={isDeleting}
            onClick={onConfirm}
          >
            {isDeleting ? (
              <>
                <Loader2 className="h-4 w-4 animate-spin" />
                <span>Deleting...</span>
              </>
            ) : (
              "Delete"
            )}
          </button>
        </div>
      </div>
    </div>
  );
};

export default DeleteCauseModal;
